import React from "react";
import { Switch, Box } from "@mui/joy";
import type { Dispatch, SetStateAction } from "react";
import DarkTypography from "../../common/DarkTypography";
import { ctaAccentColor, textTokens } from "../../../styles/globalStyles";

type GdprComponentProps = {
  gdpr: boolean | undefined;
  setGdpr: Dispatch<SetStateAction<boolean>>;
};

export default function GdprComponent({ gdpr, setGdpr }: GdprComponentProps) {
  const handleSwitchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setGdpr(event.target.checked);
  };

  return (
    <Box sx={{ padding: 1, textAlign: "center" }}>
      <DarkTypography colorVariant="secondary" sx={{ marginBottom: 1 }}>
        Voulez-vous recevoir nos communications ?
      </DarkTypography>
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
        <DarkTypography colorVariant="secondary" sx={{ marginRight: 2 }}>
          Non
        </DarkTypography>
        <Switch
          checked={gdpr || false}
          onChange={handleSwitchChange}
          size="md"
          color="primary"
          sx={{
            "--Switch-thumbSize": "16px",
            "& .MuiSwitch-action": { borderRadius: 16 },
            "&.Mui-checked": {
              "--Switch-trackBackground": ctaAccentColor,
              "--Switch-trackColor": textTokens.color.inverse,
            },
          }}
        />
        <DarkTypography colorVariant="secondary" sx={{ marginLeft: 2 }}>
          Oui
        </DarkTypography>
      </Box>
    </Box>
  );
}
